<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-toc" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/majorcharactersinthenovel"><span class="item-title-text">Major Characters in the Novel</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/foreword"><span class="item-title-text">Foreword</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/withthanks"><span class="item-title-text">With Thanks</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children">
<p class="item-title"><a href="#/upart001"><span class="item-title-text">Book One</span></a></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter001"><span class="item-title-text">Chapter 1</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter002" title="Link target outside of Sample"><span class="item-title-text">Chapter 2</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter003" title="Link target outside of Sample"><span class="item-title-text">Chapter 3</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter004" title="Link target outside of Sample"><span class="item-title-text">Chapter 4</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter005" title="Link target outside of Sample"><span class="item-title-text">Chapter 5</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter006" title="Link target outside of Sample"><span class="item-title-text">Chapter 6</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter007" title="Link target outside of Sample"><span class="item-title-text">Chapter 7</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter008" title="Link target outside of Sample"><span class="item-title-text">Chapter 8</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter009" title="Link target outside of Sample"><span class="item-title-text">Chapter 9</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter010" title="Link target outside of Sample"><span class="item-title-text">Chapter 10</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter011" title="Link target outside of Sample"><span class="item-title-text">Chapter 11</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter012" title="Link target outside of Sample"><span class="item-title-text">Chapter 12</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart001chapter013" title="Link target outside of Sample"><span class="item-title-text">Chapter 13</span></span></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children">
<p class="item-title"><span href="#/upart002" title="Link target outside of Sample"><span class="item-title-text">Book Two</span></span></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart002chapter014" title="Link target outside of Sample"><span class="item-title-text">Chapter 14</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart002chapter015" title="Link target outside of Sample"><span class="item-title-text">Chapter 15</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart002chapter016" title="Link target outside of Sample"><span class="item-title-text">Chapter 16</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart002chapter017" title="Link target outside of Sample"><span class="item-title-text">Chapter 17</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart002chapter018" title="Link target outside of Sample"><span class="item-title-text">Chapter 18</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart002chapter019" title="Link target outside of Sample"><span class="item-title-text">Chapter 19</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart002chapter020" title="Link target outside of Sample"><span class="item-title-text">Chapter 20</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart002chapter021" title="Link target outside of Sample"><span class="item-title-text">Chapter 21</span></span></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children">
<p class="item-title"><span href="#/upart003" title="Link target outside of Sample"><span class="item-title-text">Book Three</span></span></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart003chapter022" title="Link target outside of Sample"><span class="item-title-text">Chapter 22</span></span></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children">
<p class="item-title"><span href="#/upart004" title="Link target outside of Sample"><span class="item-title-text">Book Four</span></span></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart004chapter023" title="Link target outside of Sample"><span class="item-title-text">Chapter 23</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart004chapter024" title="Link target outside of Sample"><span class="item-title-text">Chapter 24</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart004chapter025" title="Link target outside of Sample"><span class="item-title-text">Chapter 25</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart004chapter026" title="Link target outside of Sample"><span class="item-title-text">Chapter 26</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart004chapter027" title="Link target outside of Sample"><span class="item-title-text">Chapter 27</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart004chapter028" title="Link target outside of Sample"><span class="item-title-text">Chapter 28</span></span></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children">
<p class="item-title"><span href="#/upart005" title="Link target outside of Sample"><span class="item-title-text">Book Five</span></span></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart005chapter029" title="Link target outside of Sample"><span class="item-title-text">Chapter 29</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart005chapter030" title="Link target outside of Sample"><span class="item-title-text">Chapter 30</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart005chapter031" title="Link target outside of Sample"><span class="item-title-text">Chapter 31</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart005chapter032" title="Link target outside of Sample"><span class="item-title-text">Chapter 32</span></span></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children">
<p class="item-title"><span href="#/upart006" title="Link target outside of Sample"><span class="item-title-text">Book Six</span></span></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart006chapter033" title="Link target outside of Sample"><span class="item-title-text">Chapter 33</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart006chapter034" title="Link target outside of Sample"><span class="item-title-text">Chapter 34</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart006chapter035" title="Link target outside of Sample"><span class="item-title-text">Chapter 35</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart006chapter036" title="Link target outside of Sample"><span class="item-title-text">Chapter 36</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart006chapter037" title="Link target outside of Sample"><span class="item-title-text">Chapter 37</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart006chapter038" title="Link target outside of Sample"><span class="item-title-text">Chapter 38</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart006chapter039" title="Link target outside of Sample"><span class="item-title-text">Chapter 39</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/upart006chapter040" title="Link target outside of Sample"><span class="item-title-text">Chapter 40</span></span></p>
</div>
</div>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="item-title-text">About the Author</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/ifyouliked" title="Link target outside of Sample"><span class="item-title-text">If You Liked …</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/otherwordfirepresstitlesbyallendrury" title="Link target outside of Sample"><span class="item-title-text">Other WordFire Press Titles by Allen Drury</span></span></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?390e3665